// extracted by mini-css-extract-plugin
export var textInput = "_dq-0";